import React from "react";
import { useBanner } from "../components/BannerContext";

export default function Banner() {
  const { banner } = useBanner();

  if (!banner) return null;

  const color =
    banner.type === "error"
      ? "bg-red-100 text-red-700"
      : banner.type === "success"
      ? "bg-green-100 text-green-700"
      : "bg-yellow-100 text-yellow-700";

  return (
    <div className={`p-3 text-sm rounded mb-4 ${color}`}>
      {banner.message}
    </div>
  );
}
